import PropTypes from 'prop-types';

import Text from 'shopper/components/Text';

import ErrorBoundary from 'components/ErrorBoundary';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import StoreWithCouponsSearch from './StoreWithCouponsSearch';

const onStoreWithCouponsSearchClick = (gaEventCategory) => {
  sendEvent({ action: 'search_store', category: gaEventCategory });
};

const StoreWithCouponsSearchBox = ({ gaEventCategory }) => (
  <ErrorBoundary>
    <section className="flex flex-col gap-4">
      <Text>{placeholder('descriptions.alternativeWayToFindStores')}</Text>
      <StoreWithCouponsSearch
        gaEventCategory={gaEventCategory}
        onClick={() => {
          onStoreWithCouponsSearchClick(gaEventCategory);
        }}
      />
    </section>
  </ErrorBoundary>
);

StoreWithCouponsSearchBox.prototypes = {
  gaEventCategory: PropTypes.string.isRequired,
};

export default StoreWithCouponsSearchBox;
